import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../themes'

export const StyleUserSettings = styled.div`
  height: 100%;

  .div-content{
    height: calc(100% - 150px);
    margin-top: 100px;
  }
  .profile-setting {
    width: calc(100% - 118px);
    height: calc(100% - 252px);
    margin-top: 80px;
    margin-bottom: 80px;
    margin-left: 80px;
    display: flex;
    background: transparent;
  }
  .profile, .setting {
    padding: 80px 50px;
    flex: 1;
    display: flex;
    justify-content: center;
  }
  .profile {
    border-right: 3px solid ${COLOR.GRAY_18};
  }
  .profile-item, .setting-item {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .setting-item {
    align-items: baseline;
    margin-top: 20px;
  }
  .profile-image {
    position: relative;
  }
  .profile-image img {
    height: 150px;
    border-radius: 50%;
    width: 150px;
    object-fit: cover;
  }
  .profile-text {
    text-align: left;
    padding: 20px 0px;
    color: ${COLOR.BLACK_4};
    .name {
      font-size: ${FONT_SIZE.LG};
    }
    .email {
      font-size: ${FONT_SIZE.SM};
      margin-top: 20px;
    }
    .name2 {
      margin-left: 20px;
    }
    .email2 {
      font-size: ${FONT_SIZE.SM};
      margin-left: 20px;
    }
  }

  .setting-language {
    align-items: baseline;
    display: flex;
    justify-content: center;
    flex-direction: row;
  }
  .setting-language img {
    height: 16px;
    width: 16px;
    padding-right: 20px;
  }
  .setting-language p {
    text-align: left;
    font: Bold 22px/30px Nunito;
    letter-spacing: 0;
    color: ${COLOR.BLACK_4}
  }
  .setting-dropdown {
    width: 200px;
  }
  .edit_circle {
    right: 0;
    bottom: 0;
    position: absolute;
    background: ${COLOR.WHITE};
    border-radius: 50%;
    width: 39px;
    height: 39px;
    align-items: center;
    justify-content: center;
    display: flex;
    box-shadow: 0px 3px 6px #9E9E9F66;
    margin-right: 10px;
  }
  .edit_circle img{
    border-radius: 0;
    width: 16px;
    height: 16px;
  }
  .margin-bot {
    margin-bottom: 30px;
  }

`
